import { render, staticRenderFns } from "./DuplicateDays.vue?vue&type=template&id=2d097d68&"
import script from "./DuplicateDays.vue?vue&type=script&lang=js&"
export * from "./DuplicateDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports